import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const customStyles = {
  option: (provided, { isDisabled, isFocused, isSelected }) => ({
    ...provided,
    color: "gray",
    padding: 20,
    borderRadius: "5px",
    backgroundColor: isDisabled
      ? null
      : isSelected
      ? "rgba(91, 182, 146, 0.15)"
      : isFocused
      ? "rgba(91, 182, 146, 0.15)"
      : null,
    ":active": {
      ...provided[":active"],
      backgroundColor:
        !isDisabled &&
        (isSelected ? "rgba(91, 182, 146, 0.15)" : "rgba(91, 182, 146, 0.15)"),
    },
  }),
  control: (base) => ({
    ...base,
    minWidth: 155,
    height: 48,
    border: "none",
    backgroundColor: "#2eb790",
    color: "#000",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";
    return { ...provided, opacity, transition, color: "white" };
  },
  multiValue: (style) => ({
    ...style,
    backgroundColor: "#2eb790",
    minWidth: "76px",
    ":hover": {
      border: "1px solid #fff",
    },
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    marginTop: "2px",
    color: "#fff",
    ":hover": {
      backgroundColor: "transparent",
      cursor: "pointer",
    },
  }),
  menuList: (base) => ({
    ...base,
    border: "1px solid #2eb790",
    borderRadius: "5px",
  }),
};

const SearchBar = ({
  placeHolderText = "Search by user, team or organization",
  term,
  handleChange,
  handleSubmit,
  handleOnChange,
  searchData,
  searchOptions,
  searchForTerm,
  resetSearch
}) => {
  return (
    <div className="search_wrapper">
      <div className="search_input--wrapper">
        <form onSubmit={handleSubmit} className="search_bar_flex_box">
          <input
            className= {"input input--search_input " + (placeHolderText === "Search for a skill" ? "input--skill" : "")}
            type="search"
            name="q"
            placeholder={placeHolderText}
            aria-label="Search bar"
            onChange={handleChange}
            value={term}
            pattern="^[a-zA-Z0-9 ]+"
            required
          />
          <Button
            className= "input input--search" 
            type="submit"
            aria-label="Search"
          >
            <SearchRoundedIcon />
          </Button>
        </form>

      </div>
    </div>
  );
};

export default SearchBar;

SearchBar.propTypes = {
  placeHolderText: PropTypes.string,
  term: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
